/**
 * 组件信息
 */
export const info = {
  name: 'xy-wave-progress', // 组件名
  type: 'component-base', // 组件类型
  label: '水波进度', // 组件label
  icon: 'icon-xy-wave-progress', // 组件图标
  defaultWidth: 300, // 组件默认宽度
  defaultHeight: 300 // 组件默认高度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      name: '',
      type: '',
      uuid: '',
      hiden: false,
      animations: [],
      style: {},
      data: {},
      languages: [],
      dataSource: null,
      events: []
    })
  },
  // 当前进度值
  value: { type: Number, default: 50 },
  // 最大进度值
  maxValue: { type: Number, default: 100 },
  // 背景颜色
  backgroundColor: { type: String, default: '' },
  // 进度颜色
  progressColor: { type: String, default: '#409EFF' },
  // 水波方向：vertical(垂直向上) / horizontal(水平向右)
  direction: { type: String, default: 'vertical' },
  // 是否开启动画
  animate: { type: Boolean, default: true }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input-number',
    label: '当前进度值',
    propKey: 'value',
    isActivityData: true
  },
  {
    type: 'xy-form-input-number',
    label: '最大进度值',
    propKey: 'maxValue',
    isActivityData: true
  },
  {
    type: 'xy-form-color-picker',
    label: '背景颜色',
    propKey: 'backgroundColor',
    showAlpha: true
  },
  {
    type: 'xy-form-color-picker',
    label: '进度颜色',
    propKey: 'progressColor',
    showAlpha: true
  },
  {
    type: 'xy-form-select',
    label: '水波方向',
    propKey: 'direction',
    options: [
      { label: '垂直向上', value: 'vertical' },
      { label: '水平向右', value: 'horizontal' }
    ]
  },
  {
    type: 'xy-form-switch',
    label: '开启动画',
    propKey: 'animate'
  }
]
